export const API_ENDPOINTS = {
  // Endpoints pour les admins
  ADMINS: {
    LIST: `/users`,
    GET_BY_ID: (id: number) => `/users/${id}`,
    DELETE: (id: number) => `/users/${id}`,
    CREATE: `/users`,
    UPDATE: (id: number) => `/users/${id}`,
  },

  // Endpoints pour les utilisateurs
  USERS: {
    LIST: `/users`,
    GET_BY_ID: (id: number) => `/users/${id}`,
    DELETE: (id: number) => `/users/${id}`,
    CREATE: `/users`,
    UPDATE: (id: number) => `/users/${id}`,
    SEARCH: `/users/search`,
    DOCTORS: {
      LIST: `/users/doctors`,
      GET_BY_ID: (id: number) => `/users/doctors/${id}`,
      UPDATE: (id: number) => `/users/doctors/${id}`,
      DELETE: (id: number) => `/users/doctors/${id}`,
      SORTED: `/users/doctors/sorted`,
      SPECIALTIES: `/users/doctors/specialties`,
    },
  },

  // Endpoints pour l'authentification
  AUTH: {
    LOGIN: `/auth/login`,
    REGISTER: `/auth/register`,
    REFRESH: `/auth/refresh`,
    LOGOUT: `/auth/logout`,
    FORGOT_PASSWORD: `/auth/forgot-password`,
    RESET_PASSWORD: `/auth/reset-password`,
  },

  // Endpoints pour les constantes
  CONSTANTES: {
    LIST: `/constantes`,
    CREATE: `/constantes`,
    GET_BY_ID: (id: number) => `/constantes/${id}`,
    UPDATE: (id: number) => `/constantes/${id}`,
    DELETE: (id: number) => `/constantes/${id}`,
    BY_PATIENT: (id: number) => `/constantes/patient/${id}`,
    BY_DOCTOR: (doctorId: string | number, params: string = '') =>
      `/constantes/doctor/${doctorId}${params}`,
    MALADE: (id: number) => `/constantes/malade/${id}`,
    DOCTOR: {
      MINE: `/doctor/constantes/mine`,
      GET_BY_ID: (id: number) => `/doctor/constantes/${id}`,
      LIST: `/doctor/constantes`,
      CREATE: `/doctor/constantes`,
      UPDATE: (id: number) => `/doctor/constantes/${id}`,
      DELETE: (id: number) => `/doctor/constantes/${id}`,
    },
    MARK_AS_CONSULTED: (id: number) =>
      `/constantes/${id}/mark-as-consulted`,
  },

  // Endpoints pour les patients
  PATIENTS: {
    LIST: `/patients`,
    CREATE: `/patients`,
    GET_BY_ID: (id: number) => `/patients/${id}`,
    UPDATE: (id: number) => `/patients/${id}`,
    DELETE: (id: number) => `/patients/${id}`,
    MALADE: (id: number) => `/patients/malade/${id}`,
    WITH_CONSTANTE: `/patients/with-constante`,
    SEARCH: `/patients/search`,
    COUNT: `/patients/count`,
    UNPAID_SUM: `/patients/unpaid/sum`,
  },

  // Endpoints pour les consultations/dossiers médicaux
  MEDICAL_RECORDS: {
    LIST: `/medical-records`,
    CREATE: `/medical-records`,
    GET_BY_ID: (id: number) => `/medical-records/${id}`,
    UPDATE: (id: number) => `/medical-records/${id}`,
    DELETE: (id: number) => `/medical-records/${id}`,
    BY_PATIENT: (id: number) =>
      `/medical-records/by-patient/${id}`,
    PATIENT: (id: number) => `/medical-records/patient/${id}`,
    UPLOAD_ANALYSIS: (id: number) => `/medical-records/${id}/upload-analysis`,
  },

  // Endpoints pour les rendez-vous
  APPOINTMENTS: {
    LIST: `/appointments`,
    CREATE: `/appointments`,
    GET_BY_ID: (id: number) => `/appointments/${id}`,
    UPDATE: (id: number) => `/appointments/${id}`,
    DELETE: (id: number) => `/appointments/${id}`,
    CANCEL: (id: number) => `/appointments/${id}/cancel`,
    MINE: `/appointments/mine`,
  },

  // Endpoints pour les consultations
  CONSULTATIONS: {
    LIST: `/consultations`,
    GET_BY_ID: (id: number) => `/consultations/${id}`,
    UPDATE: (id: number) => `/consultations/${id}`,
    DELETE: (id: number) => `/consultations/${id}`,
  },

  // Endpoints pour les prescriptions
  PRESCRIPTIONS: {
    BASE: `/prescriptions`,
    GET_BY_ID: (id: number) => `/prescriptions/${id}`,
    BY_PATIENT: (patientId: number) => `/prescriptions/patient/${patientId}`,
  },

  // Endpoints pour les médicaments
  MEDICAMENTS: {
    BASE: `/medicaments`,
    SEARCH: (query: string) => `/medicaments/search?query=${encodeURIComponent(query)}`,
    CREATE: `/medicaments`,
  },

  // Endpoints pour les antécédents médicaux
  MEDICAL_HISTORY: {
    BASE: `/medical-histories`,
    BY_PATIENT: (patientId: number) => `/medical-histories/patient/${patientId}`,
    GET_BY_ID: (id: number) => `/medical-histories/${id}`,
  },

  // Endpoints pour les docteurs
  DOCTORS: {
    LIST: `/doctors`,
  },
};

// Fonction utilitaire pour obtenir les headers d'autorisation
export const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
};

// Fonction utilitaire pour les requêtes avec gestion d'erreur
export const apiRequest = async (url: string, options: RequestInit = {}) => {
  const defaultOptions: RequestInit = {
    headers: {
      ...getAuthHeaders(),
      ...options.headers,
    },
  };

  const response = await fetch(url, { ...defaultOptions, ...options });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

// Fonction utilitaire pour les redirections basées sur le rôle
export const redirectByRole = (
  role: string,
  navigate: (path: string) => void
) => {
  const roleRoutes = {
    ADMIN: "/admin/dashboard/accueil",
    DOCTOR: "/doctor/dashboard",
    PATIENT: "/dashboard",
  } as const;

  const route = roleRoutes[role as keyof typeof roleRoutes] || "/";
  navigate(route);
};
